import { render, staticRenderFns } from "./DesktopOffer.vue?vue&type=template&id=6c13d964"
import script from "./DesktopOffer.vue?vue&type=script&lang=js"
export * from "./DesktopOffer.vue?vue&type=script&lang=js"
import style0 from "./DesktopOffer.vue?vue&type=style&index=0&id=6c13d964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports